import React, {useRef, useState} from 'react';
import ImageHelper from '@core/scripts/helper/image-helper';

const ZOOM_WIDTH = 1390;
const ZOOM_HEIGHT = 1960;

export default function ProductImageZoom({image, zoomEnabled, onZoomImageLeave}) {
    const [loaded, setLoaded] = useState(false);
    const [style, setStyle] = useState(null);

    const zoomImageRef = useRef(null);
    const zoomContainerRef = useRef(null);

    const onMouseMove = (event) => {
        const zoomContainer = zoomContainerRef.current;
        const zoomContainerBoundingClientRect = zoomContainer?.getBoundingClientRect();
        const xPosition = event.clientX - zoomContainerBoundingClientRect.left;
        const yPosition = event.clientY - zoomContainerBoundingClientRect.top;
        const imageOffsetX = (xPosition / zoomContainer.offsetWidth) * (ZOOM_WIDTH - zoomContainer.offsetWidth);
        const imageOffsetY = (yPosition / zoomContainer.offsetHeight) * (ZOOM_HEIGHT - zoomContainer.offsetHeight);

        setStyle({
            transform: `translate3d(-${imageOffsetX}px, -${imageOffsetY}px, 0)`,
            visibility: 'visible',
            width: `${ZOOM_WIDTH}px`,
            height: `${ZOOM_HEIGHT}px`,
        });
    };

    const onMouseLeave = () => {
        if (zoomEnabled) {
            onZoomImageLeave?.();
        }
    };

    const detailImage = image.detail.sources[0].srcSet;
    const detailSrc = detailImage.src;
    const detailSrcSet = ImageHelper.getSrcSetPathOf(detailImage);

    return (
        <div
            className="product-image__zoom-container"
            ref={zoomContainerRef}
            onMouseMove={onMouseMove}
            onMouseLeave={onMouseLeave}
        >
            <img
                ref={zoomImageRef}
                src={detailSrc}
                srcSet={detailSrcSet}
                alt={image.preview.alt}
                title={image.preview.alt}
                width={ZOOM_WIDTH}
                height={ZOOM_HEIGHT}
                style={loaded ? style : {display: 'none'}}
                onLoad={() => setLoaded(true)}
                className="product-image__zoom-image"
            />
            <div className="product-image__zoom-overlay" />
        </div>
    );
}
